import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class MemberRedeemApp extends React.Component
{
    constructor(props){
        super(props);
        Tools.init();
        API.init(this);
        
        setTimeout( function(){
            alert("[TODO] 沒有提供介面和對應欄位資料");
        },500);
        this.state = {
            // ty: this.E_TYPE.ALL,
            tac: this.props.match.params["id"] || "",
            list: [],
            page_max: 20,
            filter: null,
            list_index_min:0,
            list_index_max:20,
            page_index:0,
            fields: [
                "禮物編號",
                "禮物名稱",
                "序號",
                "換獎時間",
                "點數"
            ]
        };
        this.getData();
        this.onListViewClicked = this.onListViewClicked.bind(this);
    }
    getData(){
        var tmpData = {
            tac: this.state.tac
        };
        API.GetMemberPointRecord(tmpData, this.onDataUpdated.bind(this));
    }

    onListViewClicked(index){
        console.log(index);
    }

    onDataUpdated(data){
        console.log(this);
        if( data && data.data ){
            console.log(data);

            data.data = data.data.filter(function(val){
                return (2==val.type || 3==val.type || 4==val.type );
            });
            const tmp = [];
            /* {
                
            } */
            for( let index in data.data ) {
                const tmpObj = data.data[index];
                // "禮物編號",
                // "禮物名稱",
                // "序號",
                // "換獎時間",
                // "點數"
                tmp.push({
                    key: tmpObj.pid,
                    data: [
                        tmpObj.ct,
                        tmpObj.snapshot.name,
                        tmpObj.point,
                        "?"
                    ]
                });
            }
            this.setState({
                list: tmp
            })
        }
    }
    render() {
        const { list, page_max, filter, list_index_min, list_index_max, fields } = this.state,
            totalEntries = list.length,
            onListViewClicked = this.onListViewClicked;
        return (
            <div>
                <ListView list={list} 
                          fields={fields}
                          title={"兌獎紀錄"}
                          onRowClicked={onListViewClicked}/>
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(MemberRedeemApp),
//     document.getElementById('root')
// );
const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(MemberRedeemApp))